var modal = document.querySelector("#contact-modal")
var modalTrigger = document.querySelectorAll(".launch-contact");
var body = document.querySelector("body");

function bodyAddClassOnHover(className, bodyClassName) {
  const elements = document.querySelectorAll('.' + className);
  const body = document.body;
  
  function handleMouseEnter() {
    body.classList.add(bodyClassName);
  }
  
  function handleMouseLeave() {
    body.classList.remove(bodyClassName);
  }
  
  elements.forEach(element => {
    element.addEventListener('mouseenter', handleMouseEnter);
    element.addEventListener('mouseleave', handleMouseLeave);
  });
}

  if (modal && modalTrigger) {
  

  modalTrigger.forEach((i) => {
    i.addEventListener("click", () => {
      body.classList.add("modal-open", "overflow-hidden");
      modal.classList.remove("hidden");
      modal.classList.add("flex");
      modal.lastElementChild.firstElementChild.focus();
      setTimeout(function() {
        body.classList.add("modal-animate");
      }, 3);
    });
    modal.firstElementChild.addEventListener("click", () => {
      body.classList.remove("modal-open", "overflow-hidden");
      modal.classList.add("hidden");
      modal.classList.remove("flex");


      setTimeout(function() {
        body.classList.remove("modal-animate");
    }, 200);
    });
    modal.lastElementChild.firstElementChild.addEventListener("click", () => {
      body.classList.remove("modal-open", "overflow-hidden");
      modal.classList.add("hidden");
      modal.classList.remove("flex");

  
      setTimeout(function() {
        body.classList.remove("modal-animate");
    }, 200);
    });


});

  }